import React from "react";
import ReactLoading from "react-loading";
const Loading = (props) => {
  return (
    <div className="loading">
      <div style={{ flex: "auto" }}>
        <ReactLoading color={"#EFEFEF"} height={"100%"} width={"100%"} />
      </div>
    </div>
  );
};

export default Loading;
